<div class="edit">
  <mat-progress-bar *ngIf="loading || saving" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="error" class="edit__error">{{ error }}</div>

  <mat-card class="edit__card">
    <h2 class="edit__title">
      <mat-icon>pie_chart</mat-icon>
      {{ isEdit ? 'Edit distributions' : 'Add new distribution' }}
    </h2>

    <form [formGroup]="form" (ngSubmit)="save()">
      <!-- Start / end month -->
      <div class="edit__row">
        <mat-form-field appearance="outline" class="edit__month">
          <mat-label>Start on</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startMonth" readonly
                 (click)="startPicker.open()" placeholder="MM/YYYY">
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker startView="multi-year"
                          (monthSelected)="onMonthSelected($event, 'startMonth', startPicker)">
          </mat-datepicker>
          <mat-error>Start month is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="edit__month">
          <mat-label>Ends</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endMonth" readonly
                 (click)="endPicker.open()" placeholder="MM/YYYY">
          <button *ngIf="form.get('endMonth')?.value" matIconSuffix mat-icon-button type="button"
                  (click)="$event.stopPropagation(); clearEnd()" aria-label="Clear end month">
            <mat-icon>close</mat-icon>
          </button>
          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker startView="multi-year"
                          (monthSelected)="onMonthSelected($event, 'endMonth', endPicker)">
          </mat-datepicker>
        </mat-form-field>
      </div>

      <p class="edit__hint">Select the day ranges for your automatic distributions every month.</p>

      <!-- Range 1 -->
      <div class="edit__rangerow">
        <span class="edit__rangelabel">Range 1</span>
        <mat-form-field appearance="outline" class="edit__day">
          <mat-label>Starts</mat-label>
          <mat-select formControlName="range0Start">
            <mat-option *ngFor="let d of days" [value]="d.value">{{ d.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="edit__to">to</span>
        <mat-form-field appearance="outline" class="edit__day">
          <mat-label>Ends</mat-label>
          <mat-select formControlName="range0End">
            <mat-option *ngFor="let d of days" [value]="d.value">{{ d.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="edit__suffix">of every month</span>
      </div>

      <!-- Range 2 -->
      <div class="edit__rangerow">
        <span class="edit__rangelabel">Range 2</span>
        <mat-form-field appearance="outline" class="edit__day">
          <mat-label>Starts</mat-label>
          <mat-select formControlName="range1Start">
            <mat-option *ngFor="let d of days" [value]="d.value">{{ d.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="edit__to">to</span>
        <mat-form-field appearance="outline" class="edit__day">
          <mat-label>Ends</mat-label>
          <mat-select formControlName="range1End">
            <mat-option *ngFor="let d of days" [value]="d.value">{{ d.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <span class="edit__suffix">of every month</span>
      </div>

      <div class="edit__actions">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="saving">Save</button>
      </div>
    </form>
  </mat-card>
</div>
